module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "components-container",
    attrs: {
      "id": "mobileViewPort"
    }
  }, [_c('div', {
    attrs: {
      "id": "mobileMode"
    }
  }, [_c('div', {
    attrs: {
      "id": "titleArea"
    }
  }, [_c('div', {
    staticClass: "titleText"
  }, [_vm._v("学籍异动")]), _vm._v(" "), _c('div', {
    staticClass: "titleButton"
  }, [_c('el-button', {
    staticClass: "custom-el-button",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showHomePage
    }
  }, [_c('i', {
    staticClass: "el-icon-s-home"
  }), _vm._v(" 首页\n                ")])], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "queryArea"
    }
  }, [_c('div', {
    staticClass: "filter-container"
  }, [_c('div', {
    staticClass: "formItem"
  }, [(_vm.teaAuthVisible) ? _c('el-input', {
    attrs: {
      "placeholder": "学号 / 姓名",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.stuCode),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "stuCode", $$v)
      },
      expression: "queryForm.stuCode"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stuAuthVisible) ? _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "异动类型",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.changeCode),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "changeCode", $$v)
      },
      expression: "queryForm.changeCode"
    }
  }, _vm._l((_vm.comboData.changeCode), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "formItem text-center"
  }, [_c('el-button', {
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleFilter
    }
  }, [_c('i', {
    staticClass: "el-icon-search"
  }), _vm._v(" 查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh"
  }), _vm._v(" 重置")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.queryDialogVisible = true
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-more"
  }), _vm._v(" 更多")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.addRec
    }
  }, [_c('i', {
    staticClass: "el-icon-circle-plus-outline"
  }), _vm._v(" " + _vm._s(_vm.buttonName))])], 1)])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "id": "queryDialog",
      "title": "查询信息",
      "width": "90%",
      "visible": _vm.queryDialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.queryDialogVisible = $event
      }
    }
  }, [(_vm.teaAuthVisible) ? _c('el-row', [_c('el-input', {
    attrs: {
      "placeholder": "学号 / 姓名",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.stuCode),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "stuCode", $$v)
      },
      expression: "queryForm.stuCode"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "异动类型",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.changeCode),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "changeCode", $$v)
      },
      expression: "queryForm.changeCode"
    }
  }, _vm._l((_vm.comboData.changeCode), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-row', [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "学年学期",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.semesterCode),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "semesterCode", $$v)
      },
      expression: "queryForm.semesterCode"
    }
  }, _vm._l((_vm.comboData.semester), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-row', [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "起始日期",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.queryForm.startTime),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "startTime", $$v)
      },
      expression: "queryForm.startTime"
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "结束日期",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.queryForm.endTime),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "endTime", $$v)
      },
      expression: "queryForm.endTime"
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-select', {
    attrs: {
      "placeholder": "审核状态",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.auditState),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "auditState", $$v)
      },
      expression: "queryForm.auditState"
    }
  }, _vm._l((_vm.comboData.auditState), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer text-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleFilter
    }
  }, [_vm._v("查 询")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_vm._v("重 置")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    on: {
      "click": function($event) {
        _vm.queryDialogVisible = false
      }
    }
  }, [_vm._v("取 消")])], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "listArea"
    },
    on: {
      "scroll": _vm.handleScroll
    }
  }, [(_vm.tableData == null || _vm.tableData.length == 0) ? _c('div', {
    staticClass: "cardTips"
  }, [_vm._v("没有学籍异动记录")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.tableData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "cardMain"
    }, [_c('div', {
      staticClass: "cardText"
    }, [_c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("学       号：")]), _vm._v(_vm._s(item.stuCode))]), _vm._v(" "), _c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("姓       名：")]), _vm._v(_vm._s(item.stuName))]), _vm._v(" "), _c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("异动类型：")]), _vm._v(_vm._s(item.changeName))]), _vm._v(" "), _c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("异动原因：")]), _vm._v(_vm._s(item.reasonName))]), _vm._v(" "), _c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("异动日期：")]), _vm._v(_vm._s(item.changeTime))]), _vm._v(" "), _c('div', {
      staticClass: "auditStateImg"
    }, [_c('img', {
      attrs: {
        "src": _vm.loadStateImg(item),
        "alt": ""
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "cardInput"
    }, [(item.submitState == '0') ? _c('el-button', {
      attrs: {
        "type": "warning"
      },
      on: {
        "click": function($event) {
          return _vm.modRec(item)
        }
      }
    }, [_vm._v("编辑")]) : _vm._e(), _vm._v(" "), (item.submitState == '0') ? _c('el-button', {
      attrs: {
        "type": "success"
      },
      on: {
        "click": function($event) {
          return _vm.submitRec(item)
        }
      }
    }, [_vm._v("提交")]) : _vm._e(), _vm._v(" "), (item.submitState == '0') ? _c('el-button', {
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.delRec(item)
        }
      }
    }, [_vm._v("删除")]) : _vm._e(), _vm._v(" "), (item.submitState == '1' && item.auditAuth == '0') ? _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.showDetailInfo(item)
        }
      }
    }, [_vm._v("详情")]) : _vm._e(), _vm._v(" "), (item.auditAuth == '1') ? _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.auditRec(item)
        }
      }
    }, [_vm._v("审核")]) : _vm._e(), _vm._v(" "), (item.submitState == '1' || item.auditState != '') ? _c('el-button', {
      on: {
        "click": function($event) {
          return _vm.showAuditList(item)
        }
      }
    }, [_vm._v("审核信息")]) : _vm._e()], 1)])
  }), _vm._v(" "), (_vm.total > 2 && _vm.total > _vm.tableData.length) ? _c('div', {
    attrs: {
      "id": "loadingTips"
    }
  }, [_c('i', {
    staticClass: "el-icon-loading"
  }), _vm._v(" 信息加载中，请稍候...\n            ")]) : _vm._e()], 2), _vm._v(" "), _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "id": "mainDialog",
      "title": _vm.dialogTitle,
      "visible": _vm.dialogVisible,
      "width": "90%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "closed": _vm.closeDialog
    }
  }, [_c('el-scrollbar', {
    ref: "mainDialogScroll",
    attrs: {
      "id": "mainDialogScroll"
    }
  }, [_c('el-form', {
    ref: "changeStatusForm",
    attrs: {
      "model": _vm.curdForm,
      "label-width": "84px",
      "label-position": "left",
      "width": "100%",
      "rules": _vm.curdRules
    }
  }, [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "label": "编号",
      "prop": "id"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.curdForm.id),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "id", $$v)
      },
      expression: "curdForm.id"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.teaAuthVisible && _vm.fieldVisible),
      expression: "teaAuthVisible && fieldVisible"
    }]
  }, [_c('el-form-item', {
    attrs: {
      "label": "学生",
      "prop": "stuInfo"
    }
  }, [_c('el-autocomplete', {
    staticClass: "inline-input",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "fetch-suggestions": _vm.querySearchStu,
      "placeholder": "可输入学号或姓名搜索学生",
      "trigger-on-focus": false,
      "clearable": ""
    },
    on: {
      "clear": _vm.clearSelectStu
    },
    model: {
      value: (_vm.stuInfo),
      callback: function($$v) {
        _vm.stuInfo = $$v
      },
      expression: "stuInfo"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.stuAuthVisible || !_vm.fieldVisible),
      expression: "stuAuthVisible || !fieldVisible"
    }],
    attrs: {
      "label": "学生",
      "prop": "stuCode"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.curdForm.stuCode + ' - ' + _vm.curdForm.stuName) + "\n                        "), _c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    model: {
      value: (_vm.curdForm.stuCode),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "stuCode", $$v)
      },
      expression: "curdForm.stuCode"
    }
  })], 1), _vm._v(" "), (_vm.fieldVisible) ? _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "异动类型",
      "prop": "changeCode"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择异动类型"
    },
    on: {
      "change": _vm.selectChangeType
    },
    model: {
      value: (_vm.curdForm.changeCode),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "changeCode", $$v)
      },
      expression: "curdForm.changeCode"
    }
  }, _vm._l((_vm.comboData.changeCode), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fieldVisible),
      expression: "!fieldVisible"
    }],
    attrs: {
      "label": "异动类型",
      "prop": "changeName"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.changeName) + "\n                    ")]), _vm._v(" "), (_vm.fieldVisible && _vm.reasonCodeVisible) ? _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "异动原因",
      "prop": "reasonCode"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择异动原因"
    },
    model: {
      value: (_vm.curdForm.reasonCode),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "reasonCode", $$v)
      },
      expression: "curdForm.reasonCode"
    }
  }, _vm._l((_vm.comboData.reasonCode), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fieldVisible),
      expression: "!fieldVisible"
    }],
    attrs: {
      "label": "异动原因"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.reasonName) + "\n                    ")]), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fieldVisible),
      expression: "fieldVisible"
    }]
  }, [_c('el-form-item', {
    attrs: {
      "label": "异动日期",
      "prop": "changeTime"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "异动日期",
      "value-format": "yyyy-MM-dd"
    },
    on: {
      "change": _vm.handleTimeChange
    },
    model: {
      value: (_vm.curdForm.changeTime),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "changeTime", $$v)
      },
      expression: "curdForm.changeTime"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fieldVisible),
      expression: "!fieldVisible"
    }],
    attrs: {
      "label": "异动日期"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.changeTime) + "\n                    ")]), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fieldVisible),
      expression: "fieldVisible"
    }]
  }, [_c('el-form-item', {
    attrs: {
      "label": "学年学期",
      "prop": "semesterCode"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择学年学期"
    },
    model: {
      value: (_vm.curdForm.semesterCode),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "semesterCode", $$v)
      },
      expression: "curdForm.semesterCode"
    }
  }, _vm._l((_vm.comboData.semester), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fieldVisible),
      expression: "!fieldVisible"
    }],
    attrs: {
      "label": "学年学期"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.semesterName) + "\n                    ")]), _vm._v(" "), (_vm.fieldVisible && _vm.schoolVisible) ? _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "去向学校",
      "prop": "newSchoolCode"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入异动去向学校"
    },
    model: {
      value: (_vm.curdForm.newSchoolCode),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "newSchoolCode", $$v)
      },
      expression: "curdForm.newSchoolCode"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fieldVisible && _vm.selectRowData.changeCode == '11'),
      expression: "!fieldVisible && selectRowData.changeCode=='11'"
    }],
    attrs: {
      "label": "去向学校"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.newSchoolCode) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "label": "原专业码",
      "prop": "oriMajorCode"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.curdForm.oriMajorCode),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "oriMajorCode", $$v)
      },
      expression: "curdForm.oriMajorCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原专业",
      "prop": "oriMajorName"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.curdForm.oriMajorName) + "\n                    ")]), _vm._v(" "), (_vm.fieldVisible && _vm.majorVisible) ? _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "现专业",
      "prop": "newMajorCode"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择现专业"
    },
    on: {
      "change": _vm.loadClassCombo
    },
    model: {
      value: (_vm.curdForm.newMajorCode),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "newMajorCode", $$v)
      },
      expression: "curdForm.newMajorCode"
    }
  }, _vm._l((_vm.comboData.major), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fieldVisible && (_vm.selectRowData.changeCode == '02' || _vm.selectRowData.changeCode == '06' || _vm.selectRowData.changeCode == '18')),
      expression: "!fieldVisible && (selectRowData.changeCode=='02' || selectRowData.changeCode=='06' || selectRowData.changeCode=='18')"
    }],
    attrs: {
      "label": "现专业"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.newMajorName) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "label": "原班级码",
      "prop": "oriClassCode"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.curdForm.oriClassCode),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "oriClassCode", $$v)
      },
      expression: "curdForm.oriClassCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原班级",
      "prop": "oriClassName"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.curdForm.oriClassName) + "\n                    ")]), _vm._v(" "), (_vm.fieldVisible && _vm.classVisible) ? _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "现班级",
      "prop": "newClassCode"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择现班级"
    },
    model: {
      value: (_vm.curdForm.newClassCode),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "newClassCode", $$v)
      },
      expression: "curdForm.newClassCode"
    }
  }, _vm._l((_vm.comboData.class), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fieldVisible && (_vm.selectRowData.changeCode == '02' || _vm.selectRowData.changeCode == '06' || _vm.selectRowData.changeCode == '18')),
      expression: "!fieldVisible && (selectRowData.changeCode=='02' || selectRowData.changeCode=='06' || selectRowData.changeCode=='18')"
    }],
    attrs: {
      "label": "现班级"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.newClassName) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fieldVisible),
      expression: "fieldVisible"
    }],
    attrs: {
      "label": "异动说明",
      "prop": "desc"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写异动说明",
      "autoComplete": "on",
      "type": "textarea",
      "rows": 5,
      "show-word-limit": "",
      "maxlength": "500"
    },
    model: {
      value: (_vm.curdForm.desc),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "desc", $$v)
      },
      expression: "curdForm.desc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fieldVisible),
      expression: "!fieldVisible"
    }],
    attrs: {
      "label": "异动说明"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.desc) + "\n                    ")])], 1)], 1), _vm._v(" "), (_vm.auditAreaVisible) ? _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('audit', {
    ref: "audit",
    attrs: {
      "itemCode": _vm.auditParam,
      "relatedCode": _vm.selectRowData ? _vm.selectRowData.id : '',
      "auditLevel": _vm.selectRowData ? _vm.selectRowData.auditLevel : ''
    },
    on: {
      "auditCallback": _vm.auditCallback
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.fieldVisible) ? _c('div', {
    staticClass: "dialog-footer text-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.formSubmiting
    },
    on: {
      "click": _vm.saveRec
    }
  }, [_vm._v("保 存")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "success",
      "loading": _vm.formSubmiting
    },
    on: {
      "click": _vm.saveAndSubmitRec
    }
  }, [_vm._v("提 交")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取 消")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.auditListDialogVisible) ? _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "title": "审核信息",
      "visible": _vm.auditListDialogVisible,
      "width": "90%"
    },
    on: {
      "update:visible": function($event) {
        _vm.auditListDialogVisible = $event
      }
    }
  }, [_c('div', [_c('auditList', {
    ref: "auditList",
    attrs: {
      "relatedCode": _vm.selectRowData.id,
      "listHeight": 450
    }
  })], 1)]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71d29037"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/statusApply.vue
// module id = 1862
// module chunks = 502